import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { homePathForRole } from '@/auth/roles';
import { AuthSplash } from '@/components/AuthSplash';

/** Sends /app to the signed-in user's role home, or to /login when signed out. */
export function RootRedirect() {
  const { session, status } = useAuth();
  if (status === 'loading') return <AuthSplash />;
  if (!session) return <Navigate to="/login" replace />;
  return <Navigate to={homePathForRole(session.user.role)} replace />;
}
